import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="as-footer">
      <div className="container">
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-2">
          <p className="footer-copyright mb-0">© {year} Allships.com.au. All rights reserved.</p>
          <Link className="footer-link" to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}
